"use strict";
const originIsoCodes = {
    AD: 'Andorra',
    AND: 'Andorra',
    AE: 'Förenade arabemiraten',
    ARE: 'Förenade arabemiraten',
    AF: 'Afghanistan',
    AFG: 'Afghanistan',
    AG: 'Antigua och Barbuda',
    ATG: 'Antigua och Barbuda',
    AI: 'Anguilla',
    AIA: 'Anguilla',
    AL: 'Albanien',
    ALB: 'Albanien',
    AM: 'Armenien',
    ARM: 'Armenien',
    AO: 'Angola',
    AGO: 'Angola',
    AQ: 'Antarktis',
    ATA: 'Antarktis',
    AR: 'Argentina',
    ARG: 'Argentina',
    AS: 'Amerikanska Samoa',
    ASM: 'Amerikanska Samoa',
    AT: 'Österrike',
    AUT: 'Österrike',
    AU: 'Australien',
    AUS: 'Australien',
    AW: 'Aruba',
    ABW: 'Aruba',
    AX: 'Åland',
    ALA: 'Åland',
    AZ: 'Azerbajdzjan',
    AZE: 'Azerbajdzjan',
    BA: 'Bosnien och Hercegovina',
    BIH: 'Bosnien och Hercegovina',
    BB: 'Barbados',
    BRB: 'Barbados',
    BD: 'Bangladesh',
    BGD: 'Bangladesh',
    BE: 'Belgien',
    BEL: 'Belgien',
    BF: 'Burkina Faso',
    BFA: 'Burkina Faso',
    BG: 'Bulgarien',
    BGR: 'Bulgarien',
    BH: 'Bahrain',
    BHR: 'Bahrain',
    BI: 'Burundi',
    BDI: 'Burundi',
    BJ: 'Benin',
    BEN: 'Benin',
    BL: 'Saint-Barthélemy',
    BLM: 'Saint-Barthélemy',
    BM: 'Bermuda',
    BMU: 'Bermuda',
    BN: 'Brunei',
    BRN: 'Brunei',
    BO: 'Bolivia',
    BOL: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BES: 'Bonaire, Sint Eustatius and Saba',
    BR: 'Brasilien',
    BRA: 'Brasilien',
    BS: 'Bahamas',
    BHS: 'Bahamas',
    BT: 'Bhutan',
    BTN: 'Bhutan',
    BV: 'Bouvetön',
    BVT: 'Bouvetön',
    BW: 'Botswana',
    BWA: 'Botswana',
    BY: 'Belarus',
    BLR: 'Belarus',
    BZ: 'Belize',
    BLZ: 'Belize',
    CA: 'Kanada',
    CAN: 'Kanada',
    CC: 'Kokosöarna',
    CCK: 'Kokosöarna',
    CD: 'Kongo-Kinshasa',
    COD: 'Kongo-Kinshasa',
    CF: 'Centralafrikanska republiken',
    CAF: 'Centralafrikanska republiken',
    CG: 'Kongo-Brazzaville',
    COG: 'Kongo-Brazzaville',
    CH: 'Schweiz',
    CHE: 'Schweiz',
    CI: 'Elfenbenskusten',
    CIV: 'Elfenbenskusten',
    CK: 'Cooköarna',
    COK: 'Cooköarna',
    CL: 'Chile',
    CHL: 'Chile',
    CM: 'Kamerun',
    CMR: 'Kamerun',
    CN: 'Kina',
    CHN: 'Kina',
    CO: 'Colombia',
    COL: 'Colombia',
    CR: 'Costa Rica',
    CRI: 'Costa Rica',
    CU: 'Kuba',
    CUB: 'Kuba',
    CV: 'Kap Verde',
    CPV: 'Kap Verde',
    CW: 'Curaçao',
    CUW: 'Curaçao',
    CX: 'Julön',
    CXR: 'Julön',
    CY: 'Cypern',
    CYP: 'Cypern',
    CZ: 'Tjeckien',
    CZE: 'Tjeckien',
    DE: 'Tyskland',
    DEU: 'Tyskland',
    DJ: 'Djibouti',
    DJI: 'Djibouti',
    DK: 'Danmark',
    DNK: 'Danmark',
    DM: 'Dominica',
    DMA: 'Dominica',
    DO: 'Dominikanska republiken',
    DOM: 'Dominikanska republiken',
    DZ: 'Algeriet',
    DZA: 'Algeriet',
    EC: 'Ecuador',
    ECU: 'Ecuador',
    EE: 'Estland',
    EST: 'Estland',
    EG: 'Egypten',
    EGY: 'Egypten',
    EH: 'Västsahara',
    ESH: 'Västsahara',
    ER: 'Eritrea',
    ERI: 'Eritrea',
    ES: 'Spanien',
    ESP: 'Spanien',
    ET: 'Etiopien',
    ETH: 'Etiopien',
    FI: 'Finland',
    FIN: 'Finland',
    FJ: 'Fiji',
    FJI: 'Fiji',
    FK: 'Falklandsöarna',
    FLK: 'Falklandsöarna',
    FM: 'Mikronesiska federationen',
    FSM: 'Mikronesiska federationen',
    FO: 'Färöarna',
    FRO: 'Färöarna',
    FR: 'Frankrike',
    FRA: 'Frankrike',
    GA: 'Gabon',
    GAB: 'Gabon',
    GB: 'Storbritannien',
    GBR: 'Storbritannien',
    GD: 'Grenada',
    GRD: 'Grenada',
    GE: 'Georgien',
    GEO: 'Georgien',
    GF: 'Franska Guyana',
    GUF: 'Franska Guyana',
    GG: 'Guernsey',
    GGY: 'Guernsey',
    GH: 'Ghana',
    GHA: 'Ghana',
    GI: 'Gibraltar',
    GIB: 'Gibraltar',
    GL: 'Grönland',
    GRL: 'Grönland',
    GM: 'Gambia',
    GMB: 'Gambia',
    GN: 'Guinea',
    GIN: 'Guinea',
    GP: 'Guadeloupe',
    GLP: 'Guadeloupe',
    GQ: 'Ekvatorialguinea',
    GNQ: 'Ekvatorialguinea',
    GR: 'Grekland',
    GRC: 'Grekland',
    GS: 'Sydgeorgien och Sydsandwichöarna',
    SGS: 'Sydgeorgien och Sydsandwichöarna',
    GT: 'Guatemala',
    GTM: 'Guatemala',
    GU: 'Guam',
    GUM: 'Guam',
    GW: 'Guinea-Bissau',
    GNB: 'Guinea-Bissau',
    GY: 'Guyana',
    GUY: 'Guyana',
    HK: 'Hongkong',
    HKG: 'Hongkong',
    HM: 'Heard- och McDonaldöarna',
    HMD: 'Heard- och McDonaldöarna',
    HN: 'Honduras',
    HND: 'Honduras',
    HR: 'Kroatien',
    HRV: 'Kroatien',
    HT: 'Haiti',
    HTI: 'Haiti',
    HU: 'Ungern',
    HUN: 'Ungern',
    ID: 'Indonesien',
    IDN: 'Indonesien',
    IE: 'Irland',
    IRL: 'Irland',
    IL: 'Israel',
    ISR: 'Israel',
    IM: 'Isle of Man',
    IMN: 'Isle of Man',
    IN: 'Indien',
    IND: 'Indien',
    IO: 'Brittiska territoriet i Indiska oceanen',
    IOT: 'Brittiska territoriet i Indiska oceanen',
    IQ: 'Irak',
    IRQ: 'Irak',
    IR: 'Iran',
    IRN: 'Iran',
    IS: 'Island',
    ISL: 'Island',
    IT: 'Italien',
    ITA: 'Italien',
    JE: 'Jersey',
    JEY: 'Jersey',
    JM: 'Jamaica',
    JAM: 'Jamaica',
    JO: 'Jordanien',
    JOR: 'Jordanien',
    JP: 'Japan',
    JPN: 'Japan',
    KE: 'Kenya',
    KEN: 'Kenya',
    KG: 'Kirgizistan',
    KGZ: 'Kirgizistan',
    KH: 'Kambodja',
    KHM: 'Kambodja',
    KI: 'Kiribati',
    KIR: 'Kiribati',
    KM: 'Komorerna',
    COM: 'Komorerna',
    KN: 'Saint Kitts och Nevis',
    KNA: 'Saint Kitts och Nevis',
    KP: 'Nordkorea',
    PRK: 'Nordkorea',
    KR: 'Sydkorea',
    KOR: 'Sydkorea',
    KW: 'Kuwait',
    KWT: 'Kuwait',
    KY: 'Caymanöarna',
    CYM: 'Caymanöarna',
    KZ: 'Kazakstan',
    KAZ: 'Kazakstan',
    LA: 'Laos',
    LAO: 'Laos',
    LB: 'Libanon',
    LBN: 'Libanon',
    LC: 'Saint Lucia',
    LCA: 'Saint Lucia',
    LI: 'Liechtenstein',
    LIE: 'Liechtenstein',
    LK: 'Sri Lanka',
    LKA: 'Sri Lanka',
    LR: 'Liberia',
    LBR: 'Liberia',
    LS: 'Lesotho',
    LSO: 'Lesotho',
    LT: 'Litauen',
    LTU: 'Litauen',
    LU: 'Luxemburg',
    LUX: 'Luxemburg',
    LV: 'Lettland',
    LVA: 'Lettland',
    LY: 'Libyen',
    LBY: 'Libyen',
    MA: 'Marocko',
    MAR: 'Marocko',
    MC: 'Monaco',
    MCO: 'Monaco',
    MD: 'Moldavien',
    MDA: 'Moldavien',
    ME: 'Montenegro',
    MNE: 'Montenegro',
    MF: 'Saint-Martin',
    MAF: 'Saint-Martin',
    MG: 'Madagaskar',
    MDG: 'Madagaskar',
    MH: 'Marshallöarna',
    MHL: 'Marshallöarna',
    MK: 'Nordmakedonien',
    MKD: 'Nordmakedonien',
    ML: 'Mali',
    MLI: 'Mali',
    MM: 'Myanmar',
    MMR: 'Myanmar',
    MN: 'Mongoliet',
    MNG: 'Mongoliet',
    MO: 'Macao',
    MAC: 'Macao',
    MP: 'Nordmarianerna',
    MNP: 'Nordmarianerna',
    MQ: 'Martinique',
    MTQ: 'Martinique',
    MR: 'Mauretanien',
    MRT: 'Mauretanien',
    MS: 'Montserrat',
    MSR: 'Montserrat',
    MT: 'Malta',
    MLT: 'Malta',
    MU: 'Mauritius',
    MUS: 'Mauritius',
    MV: 'Maldiverna',
    MDV: 'Maldiverna',
    MW: 'Malawi',
    MWI: 'Malawi',
    MX: 'Mexiko',
    MEX: 'Mexiko',
    MY: 'Malaysia',
    MYS: 'Malaysia',
    MZ: 'Moçambique',
    MOZ: 'Moçambique',
    NA: 'Namibia',
    NAM: 'Namibia',
    NC: 'Nya Kaledonien',
    NCL: 'Nya Kaledonien',
    NE: 'Niger',
    NER: 'Niger',
    NF: 'Norfolkön',
    NFK: 'Norfolkön',
    NG: 'Nigeria',
    NGA: 'Nigeria',
    NI: 'Nicaragua',
    NIC: 'Nicaragua',
    NL: 'Nederländerna',
    NLD: 'Nederländerna',
    NO: 'Norge',
    NOR: 'Norge',
    NP: 'Nepal',
    NPL: 'Nepal',
    NR: 'Nauru',
    NRU: 'Nauru',
    NU: 'Niue',
    NIU: 'Niue',
    NZ: 'Nya Zeeland',
    NZL: 'Nya Zeeland',
    OM: 'Oman',
    OMN: 'Oman',
    PA: 'Panama',
    PAN: 'Panama',
    PE: 'Peru',
    PER: 'Peru',
    PF: 'Franska Polynesien',
    PYF: 'Franska Polynesien',
    PG: 'Papua Nya Guinea',
    PNG: 'Papua Nya Guinea',
    PH: 'Filippinerna',
    PHL: 'Filippinerna',
    PK: 'Pakistan',
    PAK: 'Pakistan',
    PL: 'Polen',
    POL: 'Polen',
    PM: 'Saint-Pierre och Miquelon',
    SPM: 'Saint-Pierre och Miquelon',
    PN: 'Pitcairnöarna',
    PCN: 'Pitcairnöarna',
    PR: 'Puerto Rico',
    PRI: 'Puerto Rico',
    PS: 'Palestina',
    PSE: 'Palestina',
    PT: 'Portugal',
    PRT: 'Portugal',
    PW: 'Palau',
    PLW: 'Palau',
    PY: 'Paraguay',
    PRY: 'Paraguay',
    QA: 'Qatar',
    QAT: 'Qatar',
    RE: 'Réunion',
    REU: 'Réunion',
    RO: 'Rumänien',
    ROU: 'Rumänien',
    RS: 'Serbien',
    SRB: 'Serbien',
    RU: 'Ryssland',
    RUS: 'Ryssland',
    RW: 'Rwanda',
    RWA: 'Rwanda',
    SA: 'Saudiarabien',
    SAU: 'Saudiarabien',
    SB: 'Salomonöarna',
    SLB: 'Salomonöarna',
    SC: 'Seychellerna',
    SYC: 'Seychellerna',
    SD: 'Sudan',
    SDN: 'Sudan',
    SE: 'Sverige',
    SW: 'Sverige',
    SWE: 'Sverige',
    SG: 'Singapore',
    SGP: 'Singapore',
    SH: 'Sankta Helena, Ascension och Tristan da Cunha',
    SHN: 'Sankta Helena, Ascension och Tristan da Cunha',
    SI: 'Slovenien',
    SVN: 'Slovenien',
    SJ: 'Svalbard och Jan Mayen',
    SJM: 'Svalbard och Jan Mayen',
    SK: 'Slovakien',
    SVK: 'Slovakien',
    SL: 'Sierra Leone',
    SLE: 'Sierra Leone',
    SM: 'San Marino',
    SMR: 'San Marino',
    SN: 'Senegal',
    SEN: 'Senegal',
    SO: 'Somalia',
    SOM: 'Somalia',
    SR: 'Surinam',
    SUR: 'Surinam',
    SS: 'Sydsudan',
    SSD: 'Sydsudan',
    ST: 'São Tomé och Príncipe',
    STP: 'São Tomé och Príncipe',
    SV: 'El Salvador',
    SLV: 'El Salvador',
    SX: 'Sint Maarten',
    SXM: 'Sint Maarten',
    SY: 'Syrien',
    SYR: 'Syrien',
    SZ: 'Swaziland',
    SWZ: 'Swaziland',
    TC: 'Turks- och Caicosöarna',
    TCA: 'Turks- och Caicosöarna',
    TD: 'Tchad',
    TCD: 'Tchad',
    TF: 'Franska sydterritorierna',
    ATF: 'Franska sydterritorierna',
    TG: 'Togo',
    TGO: 'Togo',
    TH: 'Thailand',
    THA: 'Thailand',
    TJ: 'Tadzjikistan',
    TJK: 'Tadzjikistan',
    TK: 'Tokelau',
    TKL: 'Tokelau',
    TL: 'Östtimor',
    TLS: 'Östtimor',
    TM: 'Turkmenistan',
    TKM: 'Turkmenistan',
    TN: 'Tunisien',
    TUN: 'Tunisien',
    TO: 'Tonga',
    TON: 'Tonga',
    TR: 'Turkiet',
    TUR: 'Turkiet',
    TT: 'Trinidad och Tobago',
    TTO: 'Trinidad och Tobago',
    TV: 'Tuvalu',
    TUV: 'Tuvalu',
    TW: 'Taiwan',
    TWN: 'Taiwan',
    TZ: 'Tanzania',
    TZA: 'Tanzania',
    UA: 'Ukraina',
    UKR: 'Ukraina',
    UG: 'Uganda',
    UGA: 'Uganda',
    UM: 'USA:s yttre öar',
    UMI: 'USA:s yttre öar',
    US: 'USA',
    USA: 'USA',
    UY: 'Uruguay',
    URY: 'Uruguay',
    UZ: 'Uzbekistan',
    UZB: 'Uzbekistan',
    VA: 'Vatikanstaten',
    VAT: 'Vatikanstaten',
    VC: 'Saint Vincent och Grenadinerna',
    VCT: 'Saint Vincent och Grenadinerna',
    VE: 'Venezuela',
    VEN: 'Venezuela',
    VG: 'Brittiska Jungfruöarna',
    VGB: 'Brittiska Jungfruöarna',
    VI: 'Amerikanska Jungfruöarna',
    VIR: 'Amerikanska Jungfruöarna',
    VN: 'Vietnam',
    VNM: 'Vietnam',
    VU: 'Vanuatu',
    VUT: 'Vanuatu',
    WF: 'Wallis- och Futunaöarna',
    WLF: 'Wallis- och Futunaöarna',
    WS: 'Samoa',
    WSM: 'Samoa',
    YE: 'Jemen',
    YEM: 'Jemen',
    YT: 'Mayotte',
    MYT: 'Mayotte',
    ZA: 'Sydafrika',
    ZAF: 'Sydafrika',
    ZM: 'Zambia',
    ZMB: 'Zambia',
    ZW: 'Zimbabwe',
    ZWE: 'Zimbabwe',
};
const invertedOriginIsoCodesWithTwoCharacters = {
    Andorra: 'AD',
    'Förenade arabemiraten': 'AE',
    Afghanistan: 'AF',
    'Antigua och Barbuda': 'AG',
    Anguilla: 'AI',
    Albanien: 'AL',
    Armenien: 'AM',
    Angola: 'AO',
    Antarktis: 'AQ',
    Argentina: 'AR',
    'Amerikanska Samoa': 'AS',
    Österrike: 'AT',
    Australien: 'AU',
    Aruba: 'AW',
    Åland: 'AX',
    Azerbajdzjan: 'AZ',
    'Bosnien och Hercegovina': 'BA',
    Barbados: 'BB',
    Bangladesh: 'BD',
    Belgien: 'BE',
    'Burkina Faso': 'BF',
    Bulgarien: 'BG',
    Bahrain: 'BH',
    Burundi: 'BI',
    Benin: 'BJ',
    'Saint-Barthélemy': 'BL',
    Bermuda: 'BM',
    Brunei: 'BN',
    Bolivia: 'BO',
    'Bonaire, Sint Eustatius and Saba': 'BQ',
    Brasilien: 'BR',
    Bahamas: 'BS',
    Bhutan: 'BT',
    Bouvetön: 'BV',
    Botswana: 'BW',
    Belarus: 'BY',
    Belize: 'BZ',
    Kanada: 'CA',
    Kokosöarna: 'CC',
    'Kongo-Kinshasa': 'CD',
    'Centralafrikanska republiken': 'CF',
    'Kongo-Brazzaville': 'CG',
    Schweiz: 'CH',
    Elfenbenskusten: 'CI',
    Cooköarna: 'CK',
    Chile: 'CL',
    Kamerun: 'CM',
    Kina: 'CN',
    Colombia: 'CO',
    'Costa Rica': 'CR',
    Kuba: 'CU',
    'Kap Verde': 'CV',
    Curaçao: 'CW',
    Julön: 'CX',
    Cypern: 'CY',
    Tjeckien: 'CZ',
    Tyskland: 'DE',
    Djibouti: 'DJ',
    Danmark: 'DK',
    Dominica: 'DM',
    'Dominikanska republiken': 'DO',
    Algeriet: 'DZ',
    Ecuador: 'EC',
    Estland: 'EE',
    Egypten: 'EG',
    Västsahara: 'EH',
    Eritrea: 'ER',
    Spanien: 'ES',
    Etiopien: 'ET',
    Finland: 'FI',
    Fiji: 'FJ',
    Falklandsöarna: 'FK',
    'Mikronesiska federationen': 'FM',
    Färöarna: 'FO',
    Frankrike: 'FR',
    Gabon: 'GA',
    Storbritannien: 'GB',
    Grenada: 'GD',
    Georgien: 'GE',
    'Franska Guyana': 'GF',
    Guernsey: 'GG',
    Ghana: 'GH',
    Gibraltar: 'GI',
    Grönland: 'GL',
    Gambia: 'GM',
    Guinea: 'GN',
    Guadeloupe: 'GP',
    Ekvatorialguinea: 'GQ',
    Grekland: 'GR',
    'Sydgeorgien och Sydsandwichöarna': 'GS',
    Guatemala: 'GT',
    Guam: 'GU',
    'Guinea-Bissau': 'GW',
    Guyana: 'GY',
    Hongkong: 'HK',
    'Heard- och McDonaldöarna': 'HM',
    Honduras: 'HN',
    Kroatien: 'HR',
    Haiti: 'HT',
    Ungern: 'HU',
    Indonesien: 'ID',
    Irland: 'IE',
    Israel: 'IL',
    'Isle of Man': 'IM',
    Indien: 'IN',
    'Brittiska territoriet i Indiska oceanen': 'IO',
    Irak: 'IQ',
    Iran: 'IR',
    Island: 'IS',
    Italien: 'IT',
    Jersey: 'JE',
    Jamaica: 'JM',
    Jordanien: 'JO',
    Japan: 'JP',
    Kenya: 'KE',
    Kirgizistan: 'KG',
    Kambodja: 'KH',
    Kiribati: 'KI',
    Komorerna: 'KM',
    'Saint Kitts och Nevis': 'KN',
    Nordkorea: 'KP',
    Sydkorea: 'KR',
    Kuwait: 'KW',
    Caymanöarna: 'KY',
    Kazakstan: 'KZ',
    Laos: 'LA',
    Libanon: 'LB',
    'Saint Lucia': 'LC',
    Liechtenstein: 'LI',
    'Sri Lanka': 'LK',
    Liberia: 'LR',
    Lesotho: 'LS',
    Litauen: 'LT',
    Luxemburg: 'LU',
    Lettland: 'LV',
    Libyen: 'LY',
    Marocko: 'MA',
    Monaco: 'MC',
    Moldavien: 'MD',
    Montenegro: 'ME',
    'Saint-Martin': 'MF',
    Madagaskar: 'MG',
    Marshallöarna: 'MH',
    Nordmakedonien: 'MK',
    Mali: 'ML',
    Myanmar: 'MM',
    Mongoliet: 'MN',
    Macao: 'MO',
    Nordmarianerna: 'MP',
    Martinique: 'MQ',
    Mauretanien: 'MR',
    Montserrat: 'MS',
    Malta: 'MT',
    Mauritius: 'MU',
    Maldiverna: 'MV',
    Malawi: 'MW',
    Mexiko: 'MX',
    Malaysia: 'MY',
    Moçambique: 'MZ',
    Namibia: 'NA',
    'Nya Kaledonien': 'NC',
    Niger: 'NE',
    Norfolkön: 'NF',
    Nigeria: 'NG',
    Nicaragua: 'NI',
    Nederländerna: 'NL',
    Norge: 'NO',
    Nepal: 'NP',
    Nauru: 'NR',
    Niue: 'NU',
    'Nya Zeeland': 'NZ',
    Oman: 'OM',
    Panama: 'PA',
    Peru: 'PE',
    'Franska Polynesien': 'PF',
    'Papua Nya Guinea': 'PG',
    Filippinerna: 'PH',
    Pakistan: 'PK',
    Polen: 'PL',
    'Saint-Pierre och Miquelon': 'PM',
    Pitcairnöarna: 'PN',
    'Puerto Rico': 'PR',
    Palestina: 'PS',
    Portugal: 'PT',
    Palau: 'PW',
    Paraguay: 'PY',
    Qatar: 'QA',
    Réunion: 'RE',
    Rumänien: 'RO',
    Serbien: 'RS',
    Ryssland: 'RU',
    Rwanda: 'RW',
    Saudiarabien: 'SA',
    Salomonöarna: 'SB',
    Seychellerna: 'SC',
    Sudan: 'SD',
    Sverige: 'SE',
    Singapore: 'SG',
    'Sankta Helena, Ascension och Tristan da Cunha': 'SH',
    Slovenien: 'SI',
    'Svalbard och Jan Mayen': 'SJ',
    Slovakien: 'SK',
    'Sierra Leone': 'SL',
    'San Marino': 'SM',
    Senegal: 'SN',
    Somalia: 'SO',
    Surinam: 'SR',
    Sydsudan: 'SS',
    'São Tomé och Príncipe': 'ST',
    'El Salvador': 'SV',
    'Sint Maarten': 'SX',
    Syrien: 'SY',
    Swaziland: 'SZ',
    'Turks- och Caicosöarna': 'TC',
    Tchad: 'TD',
    'Franska sydterritorierna': 'TF',
    Togo: 'TG',
    Thailand: 'TH',
    Tadzjikistan: 'TJ',
    Tokelau: 'TK',
    Östtimor: 'TL',
    Turkmenistan: 'TM',
    Tunisien: 'TN',
    Tonga: 'TO',
    Turkiet: 'TR',
    'Trinidad och Tobago': 'TT',
    Tuvalu: 'TV',
    Taiwan: 'TW',
    Tanzania: 'TZ',
    Ukraina: 'UA',
    Uganda: 'UG',
    'USA:s yttre öar': 'UM',
    USA: 'US',
    Uruguay: 'UY',
    Uzbekistan: 'UZ',
    Vatikanstaten: 'VA',
    'Saint Vincent och Grenadinerna': 'VC',
    Venezuela: 'VE',
    'Brittiska Jungfruöarna': 'VG',
    'Amerikanska Jungfruöarna': 'VI',
    Vietnam: 'VN',
    Vanuatu: 'VU',
    'Wallis- och Futunaöarna': 'WF',
    Samoa: 'WS',
    Jemen: 'YE',
    Mayotte: 'YT',
    Sydafrika: 'ZA',
    Zambia: 'ZM',
    Zimbabwe: 'ZW',
};
const invertedOriginIsoCodesWithThreeCharacters = {
    Andorra: 'AND',
    'Förenade arabemiraten': 'ARE',
    Afghanistan: 'AFG',
    'Antigua och Barbuda': 'ATG',
    Anguilla: 'AIA',
    Albanien: 'ALB',
    Armenien: 'ARM',
    Angola: 'AGO',
    Antarktis: 'ATA',
    Argentina: 'ARG',
    'Amerikanska Samoa': 'ASM',
    Österrike: 'AUT',
    Australien: 'AUS',
    Aruba: 'ABW',
    Åland: 'ALA',
    Azerbajdzjan: 'AZE',
    'Bosnien och Hercegovina': 'BIH',
    Barbados: 'BRB',
    Bangladesh: 'BGD',
    Belgien: 'BEL',
    'Burkina Faso': 'BFA',
    Bulgarien: 'BGR',
    Bahrain: 'BHR',
    Burundi: 'BDI',
    Benin: 'BEN',
    'Saint-Barthélemy': 'BLM',
    Bermuda: 'BMU',
    Brunei: 'BRN',
    Bolivia: 'BOL',
    'Bonaire, Sint Eustatius and Saba': 'BES',
    Brasilien: 'BRA',
    Bahamas: 'BHS',
    Bhutan: 'BTN',
    Bouvetön: 'BVT',
    Botswana: 'BWA',
    Belarus: 'BLR',
    Belize: 'BLZ',
    Kanada: 'CAN',
    Kokosöarna: 'CCK',
    'Kongo-Kinshasa': 'COD',
    'Centralafrikanska republiken': 'CAF',
    'Kongo-Brazzaville': 'COG',
    Schweiz: 'CHE',
    Elfenbenskusten: 'CIV',
    Cooköarna: 'COK',
    Chile: 'CHL',
    Kamerun: 'CMR',
    Kina: 'CHN',
    Colombia: 'COL',
    'Costa Rica': 'CRI',
    Kuba: 'CUB',
    'Kap Verde': 'CPV',
    Curaçao: 'CUW',
    Julön: 'CXR',
    Cypern: 'CYP',
    Tjeckien: 'CZE',
    Tyskland: 'DEU',
    Djibouti: 'DJI',
    Danmark: 'DNK',
    Dominica: 'DMA',
    'Dominikanska republiken': 'DOM',
    Algeriet: 'DZA',
    Ecuador: 'ECU',
    Estland: 'EST',
    Egypten: 'EGY',
    Västsahara: 'ESH',
    Eritrea: 'ERI',
    Spanien: 'ESP',
    Etiopien: 'ETH',
    Finland: 'FIN',
    Fiji: 'FJI',
    Falklandsöarna: 'FLK',
    'Mikronesiska federationen': 'FSM',
    Färöarna: 'FRO',
    Frankrike: 'FRA',
    Gabon: 'GAB',
    Storbritannien: 'GBR',
    England: 'GBR',
    Wales: 'GBR',
    Skottland: 'GBR',
    Nordirland: 'GBR',
    Grenada: 'GRD',
    Georgien: 'GEO',
    'Franska Guyana': 'GUF',
    Guernsey: 'GGY',
    Ghana: 'GHA',
    Gibraltar: 'GIB',
    Grönland: 'GRL',
    Gambia: 'GMB',
    Guinea: 'GIN',
    Guadeloupe: 'GLP',
    Ekvatorialguinea: 'GNQ',
    Grekland: 'GRC',
    'Sydgeorgien och Sydsandwichöarna': 'SGS',
    Guatemala: 'GTM',
    Guam: 'GUM',
    'Guinea-Bissau': 'GNB',
    Guyana: 'GUY',
    Hongkong: 'HKG',
    'Heard- och McDonaldöarna': 'HMD',
    Honduras: 'HND',
    Kroatien: 'HRV',
    Haiti: 'HTI',
    Ungern: 'HUN',
    Indonesien: 'IDN',
    Irland: 'IRL',
    Israel: 'ISR',
    'Isle of Man': 'IMN',
    Indien: 'IND',
    'Brittiska territoriet i Indiska oceanen': 'IOT',
    Irak: 'IRQ',
    Iran: 'IRN',
    Island: 'ISL',
    Italien: 'ITA',
    Jersey: 'JEY',
    Jamaica: 'JAM',
    Jordanien: 'JOR',
    Japan: 'JPN',
    Kenya: 'KEN',
    Kirgizistan: 'KGZ',
    Kambodja: 'KHM',
    Kiribati: 'KIR',
    Komorerna: 'COM',
    'Saint Kitts och Nevis': 'KNA',
    Nordkorea: 'PRK',
    Sydkorea: 'KOR',
    Kuwait: 'KWT',
    Caymanöarna: 'CYM',
    Kazakstan: 'KAZ',
    Laos: 'LAO',
    Libanon: 'LBN',
    'Saint Lucia': 'LCA',
    Liechtenstein: 'LIE',
    'Sri Lanka': 'LKA',
    Liberia: 'LBR',
    Lesotho: 'LSO',
    Litauen: 'LTU',
    Luxemburg: 'LUX',
    Lettland: 'LVA',
    Libyen: 'LBY',
    Marocko: 'MAR',
    Monaco: 'MCO',
    Moldavien: 'MDA',
    Montenegro: 'MNE',
    'Saint-Martin': 'MAF',
    Madagaskar: 'MDG',
    Marshallöarna: 'MHL',
    Nordmakedonien: 'MKD',
    Mali: 'MLI',
    Myanmar: 'MMR',
    Mongoliet: 'MNG',
    Macao: 'MAC',
    Nordmarianerna: 'MNP',
    Martinique: 'MTQ',
    Mauretanien: 'MRT',
    Montserrat: 'MSR',
    Malta: 'MLT',
    Mauritius: 'MUS',
    Maldiverna: 'MDV',
    Malawi: 'MWI',
    Mexiko: 'MEX',
    Malaysia: 'MYS',
    Moçambique: 'MOZ',
    Namibia: 'NAM',
    'Nya Kaledonien': 'NCL',
    Niger: 'NER',
    Norfolkön: 'NFK',
    Nigeria: 'NGA',
    Nicaragua: 'NIC',
    Nederländerna: 'NLD',
    Norge: 'NOR',
    Nepal: 'NPL',
    Nauru: 'NRU',
    Niue: 'NIU',
    'Nya Zeeland': 'NZL',
    Oman: 'OMN',
    Panama: 'PAN',
    Peru: 'PER',
    'Franska Polynesien': 'PYF',
    'Papua Nya Guinea': 'PNG',
    Filippinerna: 'PHL',
    Pakistan: 'PAK',
    Polen: 'POL',
    'Saint-Pierre och Miquelon': 'SPM',
    Pitcairnöarna: 'PCN',
    'Puerto Rico': 'PRI',
    Palestina: 'PSE',
    Portugal: 'PRT',
    Palau: 'PLW',
    Paraguay: 'PRY',
    Qatar: 'QAT',
    Réunion: 'REU',
    Rumänien: 'ROU',
    Serbien: 'SRB',
    Ryssland: 'RUS',
    Rwanda: 'RWA',
    Saudiarabien: 'SAU',
    Salomonöarna: 'SLB',
    Seychellerna: 'SYC',
    Sudan: 'SDN',
    Sverige: 'SWE',
    Singapore: 'SGP',
    'Sankta Helena, Ascension och Tristan da Cunha': 'SHN',
    Slovenien: 'SVN',
    'Svalbard och Jan Mayen': 'SJM',
    Slovakien: 'SVK',
    'Sierra Leone': 'SLE',
    'San Marino': 'SMR',
    Senegal: 'SEN',
    Somalia: 'SOM',
    Surinam: 'SUR',
    Sydsudan: 'SSD',
    'São Tomé och Príncipe': 'STP',
    'El Salvador': 'SLV',
    'Sint Maarten': 'SXM',
    Syrien: 'SYR',
    Swaziland: 'SWZ',
    'Turks- och Caicosöarna': 'TCA',
    Tchad: 'TCD',
    'Franska sydterritorierna': 'ATF',
    Togo: 'TGO',
    Thailand: 'THA',
    Tadzjikistan: 'TJK',
    Tokelau: 'TKL',
    Östtimor: 'TLS',
    Turkmenistan: 'TKM',
    Tunisien: 'TUN',
    Tonga: 'TON',
    Turkiet: 'TUR',
    'Trinidad och Tobago': 'TTO',
    Tuvalu: 'TUV',
    Taiwan: 'TWN',
    Tanzania: 'TZA',
    Ukraina: 'UKR',
    Uganda: 'UGA',
    'USA:s yttre öar': 'UMI',
    USA: 'USA',
    Uruguay: 'URY',
    Uzbekistan: 'UZB',
    Vatikanstaten: 'VAT',
    'Saint Vincent och Grenadinerna': 'VCT',
    Venezuela: 'VEN',
    'Brittiska Jungfruöarna': 'VGB',
    'Amerikanska Jungfruöarna': 'VIR',
    Vietnam: 'VNM',
    Vanuatu: 'VUT',
    'Wallis- och Futunaöarna': 'WLF',
    Samoa: 'WSM',
    Jemen: 'YEM',
    Mayotte: 'MYT',
    Sydafrika: 'ZAF',
    Zambia: 'ZMB',
    Zimbabwe: 'ZWE',
};
module.exports = {
    originIsoCodes,
    invertedOriginIsoCodesWithThreeCharacters,
    invertedOriginIsoCodesWithTwoCharacters,
};
